/**
 * Shared UI component for UI Modal.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';
import { UiButtonComponent } from '../ui-button/ui-button.component';

@Component({
  selector: 'ui-modal',
  standalone: true,
  imports: [UiButtonComponent, UiLabelTranslatePipe],
  templateUrl: './ui-modal.component.html',
  styleUrl: './ui-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiModalComponent {
  readonly open = input(true);
  readonly title = input('');
  readonly description = input('');
  readonly allowOverflow = input(false);
  readonly showClose = input(false);
  readonly maxWidth = input('760px');
  readonly width = input<string | null>(null);
  readonly closed = output<void>();
  readonly closeAction = output<void>();

  close(): void {
    this.closed.emit();
    this.closeAction.emit();
  }
}
